//该文件用于创建VueRouter中最核心的VueRouter

//安装Vuex：npm i vue-router@3   // vue-router3版本对应vue2   vue-router4版本对应vue3
//引用：import VueRouter from "vue-router";
//使用：Vue.use(VueRouter)
//使用this.$router

import Vue from 'vue'
//引入VueRouter
import VueRouter from 'vue-router'

import MainView from '../pages/MainView.vue'
import Home from '../pages/Home'
import Master from '../pages/Master'
import Message from '../pages/Message'
import Introduction from '../pages/Introduction'
import Created from '../pages/Created'
import Exchange from '../pages/Exchange'
import newsDetail from '../pages/jl/newsDetail'
import MasterDetail from "../pages/ds/MasterDetail.vue"

import About from '../pages/dz/About'

import DownloadPage from '../pages/DownloadPage.vue'

//使用VueRouter插件
Vue.use(VueRouter)

export default new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes:[
        {
            path:'/',
            name:'main',
            redirect: '/home',
            component:MainView,
            children:[
                {
                    path: 'home',
                    name: 'home',
                    meta:{
                      KeepAlive:true
                    },
                    component: Home,
                    children:[
                        {
                            path:'about',
                            component:About
                        }
                    ]
                },
                {
                    path:'/message',
                    name: 'message',
                    component:Message
                },
                {
                    path:'/exchange',
                    name: 'exchange',
                    component:Exchange,
                    children:[
                        // {
                        //     path:'newsDetail',
                        //     name: 'newsDetail',
                        //     component:newsDetail,
                        //     props({ query: { path } }){
                        //         return {path}
                        //       }
                        // },
                    ]
                },
                {
                    path:'/master',
                    name: 'master',
                    component:Master
                },
                {
                    path:'/introduction',
                    name: 'introduction',
                    component:Introduction
                },
                {
                    path:'/created',
                    name: 'created',
                    component:Created
                },
                {
                    path:'/newsDetail',
                    name: 'newsDetail',
                    component:newsDetail,
                    props({ query: { path } }){
                        return {path}
                      }
                },
                {
                    path:'/MasterDetail',
                    name: 'MasterDetail',
                    component:MasterDetail,
                },
            ]
        },
        {
            path:'/download',
            name: 'download',
            component:DownloadPage
        },        
        
    ]
})


